// routes
import { paths } from './routes/paths';

// API
// ----------------------------------------------------------------------
export const HOST_API_LEGACY = import.meta.env.VITE_API_BASE_URL;
export const HOST_API = import.meta.env.VITE_API_BASE_URL;
export const ASSETS_API = import.meta.env.VITE_ASSETS_API;

// The wine assistant streams from its own CloudFront front door, not from
// HOST_API: API Gateway buffers response bodies, so SSE cannot cross it. The
// distribution sits in front of a Lambda Function URL with Origin Access
// Control, which is why requests to it are SigV4-signed rather than merely
// bearing a token — see assistant-signing.ts.
export const ASSISTANT_API = import.meta.env.VITE_ASSISTANT_API;

export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

export const CONFIG = {
  assetsDir: '',
  mapboxApiKey: import.meta.env.VITE_MAPBOX_API_KEY as string | undefined,
};

export const GTM_ID = import.meta.env.VITE_GTM_TAG;

export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: import.meta.env.VITE_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  callbackUrl: import.meta.env.VITE_AUTH0_CALLBACK_URL,
};

export const MAPBOX_API_KEY = import.meta.env.VITE_MAPBOX_API_KEY;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_CUSTOMER_AFTER_LOGIN = paths.customer.catalog; // as '/customer login'
// export const PATH_ADMIN_AFTER_LOGIN = paths.admin.orderTypes.clientOrders.root; // as '/admin login'
export const PATH_ADMIN_AFTER_LOGIN = paths.admin.dashboard.operations; // as '/admin login'

export const PATH_AGENT_AFTER_LOGIN = paths.admin.orderTypes.clientOrders.root; // as '/agent login'

export const PATH_AUDITOR_AFTER_LOGIN = paths.admin.orderTypes.producerOrders.root; // as '/producers login'

export const PATH_COFFEE_AFTER_LOGIN = paths.coffee.dashboard; // as '/coffee login'

export const SENTRY_CONFIG = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
  env: import.meta.env.VITE_SENTRY_ENV,
};
